import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2 rounded-sm shadow-sm w-fit" }
const _hoisted_2 = { class: "font-bold" }

import { InformationCircleIcon } from '@heroicons/vue/24/solid';


export default /*@__PURE__*/_defineComponent({
  __name: 'ShortkeysGuid',
  setup(__props) {

const shortkeys: ({ title: string, value: string })[] = [
    { title: 'Delete', value: 'Shift + DELETE' },
    { title: 'Insert', value: 'Shift + Insert' },
    { title: 'dot', value: '. OR p' },
    { title: 'Insert Measure Before Current Focused Measure', value: 'CTRL + Insert' },
    { title: 'Change Tabgrp Duration', value: 'ALT + ↑ OR ALT + ↓' },
]


return (_ctx: any,_cache: any) => {
  const _component_VaPopover = _resolveComponent("VaPopover")!

  return (_openBlock(), _createBlock(_component_VaPopover, {
    placement: "bottom-left",
    trigger: "click",
    color: "secondary"
  }, {
    title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("i", null, "Shortkeys:", -1)
    ]))]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(shortkeys, (shK, index) => {
            return _createElementVNode("li", { key: index }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(shK.title), 1),
              _createTextVNode(" : " + _toDisplayString(shK.value), 1)
            ])
          }), 64))
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(InformationCircleIcon), { class: "w-8 fill-white" })
    ]),
    _: 1
  }))
}
}

})